<template>
	<div class="apply">
		<div class="box-card">
			<div class="head">
				<span class="applyTitle">标摊门楣</span>
				<span class="applyEnd">申请截止时间：2023年9月20日</span>
			</div>

			<div class="introduce">
				<div class="txt"><span class="shuoMing">说明</span>1、标摊门楣信息只适用于标准展位的参展商填写；</div>
				<div class="txt">2、每个标准展位上只能显示一家参展商名称；</div>
				<div class="txt">3、门楣信息须同合同所使用的展商名称一致，展商须保证提供名称的正确性。</div>
			</div>

			<div class="instance">
				<p class="title">门楣实例</p>
				<div class="img">
					<img src="../../../../static/hk_bg.png" alt="" />
					<div class="backTxt">
						<div class="topText">
							<span class="companyName">公司名称</span>
							<span class="number">展位号</span>
						</div>
						<div class="topText">
							<span class="EcompanyName">COMPANY NAME</span>
							<span class="Enumber">Booth No.</span>
						</div>
					</div>
				</div>
				<div class="content">
					<el-form :model="numberValidateForm" ref="numberValidateForm" label-width="124px">
						<el-form-item label="单位名称.中文：" prop="Cname" :rules="[{ required: true }]">
							<span>{{ numberValidateForm.Cname }}</span>
						</el-form-item>

						<el-form-item
							label="单位名称.英文："
							prop="EName"
							:rules="[{ required: true, message: '单位名称不能为空' }]"
						>
							<el-input
								type="age"
								v-model="numberValidateForm.EName"
								autocomplete="off"
								placeholder="首字母大写、其余小写"
								maxlength="100"
								@keyup.native="proving"
							></el-input>
						</el-form-item>

						<el-form-item label="展位号：" prop="number" :rules="[{ required: true }]">
							<span>{{ numberValidateForm.number }}</span>
						</el-form-item>

						<el-form-item
							label="如果对展商中文名称或者展位号有疑义可以致电展会组委会"
							label-width="500px"
							class="msg"
							:rules="[{ required: true }]"
						>
							<span class="telNumber">010-84293556</span>
						</el-form-item>

						<el-form-item>
							<el-button type="primary" @click="submitForm('numberValidateForm')">提交</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			input: '',
			//表单对象
			numberValidateForm: {
				Cname: '中国煤炭工业国际技术咨询有限责任公司',
				EName: '',
				number: 123456,
			},
		};
	},

	methods: {
		//提交触发
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					alert('submit!');
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		//输入框重置
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		//

		proving() {
			this.numberValidateForm.EName = this.numberValidateForm.EName.replace(/[A-Z][a-z]+/g, '');
			this.numberValidateForm.EName = this.numberValidateForm.EName.replace('.', '');
		},
	},
};
</script>

<style scoped lang="scss">
.apply {
	padding: 17px 26px;
	box-sizing: border-box;
	background: #f0f2f5;
	.box-card {
		width: 100%;
		border-radius: 2px;
		background: #ffffff;
		.head {
			padding: 17px 0px;
			border-bottom: 1px solid #e8e8e8;
			.applyTitle {
				font-size: 17px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #333333;
				line-height: 24px;
				margin-left: 26px;
			}
			.applyEnd {
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #666666;
				line-height: 17px;
				margin-left: 17px;
			}
		}
		//说明
		.introduce {
			margin: 26px 17px 0px 17px;
			padding-bottom: 10px;
			background: #f6f6f7;
			.txt {
				padding-left: 65px;
				box-sizing: border-box;
				position: relative;
				padding-top: 9px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				.shuoMing {
					position: absolute;
					top: 9px;
					left: 26px;
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #ff190c;
				}
			}
		}
		//标题
		.instance {
			margin: 0px 17px 0px 17px;
			.title {
				padding: 35px 0px 9px 0px;
				border-bottom: 1px solid #e9e9e9;
			}
			.img {
				width: 100%;
				height: 207px;
				margin-top: 9px;
				position: relative;
				img {
					width: 100%;
					height: 207px;
				}
				.backTxt {
					width: 100%;
					height: 207px;
					position: absolute;
					top: 0px;
					left: 0px;
					.companyName {
						font-size: 31px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #006fb8;
						line-height: 43px;
						float: left;
						margin: 62px 0px 0px 47px;
					}
					.number {
						font-size: 31px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #006fb8;
						line-height: 43px;
						float: right;
						margin: 62px 47px 0px 0px;
					}

					.EcompanyName {
						font-size: 31px;
						
						float: left;
						margin-left: -125px;
						margin-top: 119px;
						font-size: 19px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #333333;
						line-height: 26px;
					}
					.Enumber {
						font-size: 31px;
						margin-right: -95px;
						margin-top: 119px;
						float: right;
						font-size: 19px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #333333;
						line-height: 26px;
					}
				}
			}
			.content {
				width: 50%;
				margin: 0 auto;
				padding-bottom: 117px;
				padding-top: 42px;
				.telNumber {
					color: #006fb8;
					margin-left: 5px;
				}
			}
		}
	}
}
</style>
<style scoped>
.el-form >>> .el-form-item__label {
	line-height: 12px;
	padding: 0px;
	font-size: 12px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	margin-top: 7px;
}
.el-form >>> .el-form-item__content {
	line-height: 28px;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #333333;
}
.el-form >>> .el-form-item {
	margin-bottom: 17px;
}
.el-form >>> .el-input {
	width: 468px;
}
.el-form >>> .el-input__inner {
	width: 468px;
	height: 28px;
}
.msg {
	margin-left: -55px;
}
.el-button--primary {
	font-size: 12px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #ffffff;
	width: 76px;
	height: 28px;
	line-height: 0px;
	background-color: #006fb8;
	text-align: center;
}
</style>
